import gql from 'graphql-tag';
import { USER_TYPE } from '../../user/graphql/UserType.gql';
// import { TOOL_TYPE } from '../../tool/graphql/ToolType.gql';

// , ${TOOL_TYPE}
export const CUSTOM_USER_COMMITMENT_TYPE = gql`
  ${USER_TYPE}
  fragment CustomUserCommitmentType on CustomUserCommitmentType {
    id
    user {
      ...UserType
    }
    title
    description
    tool {
      id
      title
      uiFlow
      thumbnailImage
      description
      status
      public
      pubDate
    }
    dueDate
    completed
    dateCreated
    dateCompleted
  }
`;
